import { render, staticRenderFns } from "./userAgreement.vue?vue&type=template&id=5e76adc2&scoped=true&"
import script from "./userAgreement.vue?vue&type=script&lang=js&"
export * from "./userAgreement.vue?vue&type=script&lang=js&"
import style0 from "./userAgreement.vue?vue&type=style&index=0&id=5e76adc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e76adc2",
  null
  
)

export default component.exports